import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialState from './state';
import { TMeetingCapability } from '@/common/basis/types/database/tmeeting-capability';

const slice = createSlice({
  name: 'whole',
  initialState,
  reducers: {
    setCapability: (state, action: PayloadAction<TMeetingCapability.Data>) => {
      state.capability = action.payload;
    },
    setIsLanguageEn: (state, action: PayloadAction<boolean>) => {
      state.isLanguageEn = action.payload;
    },
  },
});

export const { setCapability, setIsLanguageEn } = slice.actions;

export default slice.reducer;
